import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import AuthCallback from "@/pages/AuthCallback";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Catalog from "@/pages/Catalog";
import PropertyDetail from "@/pages/PropertyDetail";
import SellerDashboard from "@/pages/SellerDashboard";
import AddProperty from "@/pages/AddProperty";
import Messages from "@/pages/Messages";
import Bookings from "@/pages/Bookings";
import PaymentResult from "@/pages/PaymentResult";
import AdminPanel from "@/pages/AdminPanel";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-stone-500">Chargement…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  return children;
};

const AdminOnly = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-stone-500">Chargement…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/catalog" element={<Catalog />} />
      <Route path="/property/:id" element={<PropertyDetail />} />
      <Route path="/dashboard" element={<Protected><SellerDashboard /></Protected>} />
      <Route path="/dashboard/add" element={<Protected><AddProperty /></Protected>} />
      <Route path="/messages" element={<Protected><Messages /></Protected>} />
      <Route path="/bookings" element={<Protected><Bookings /></Protected>} />
      <Route path="/payment/success" element={<PaymentResult />} />
      <Route path="/payment/cancel" element={<PaymentResult />} />
      <Route path="/admin" element={<AdminOnly><AdminPanel /></AdminOnly>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SettingsProvider>
            <Toaster position="top-right" richColors />
            <AppRouter />
          </SettingsProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
